// ============================================================
// Donate.js
// ============================================================
import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import { Save } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Donate() {
  const api = useApi();
  const { can } = useAuth();
  const [requests, setRequests] = useState([]);
  const [settings, setSettings] = useState({
    donate_easypaisa: '03114749446',
    donate_iban: 'PK56TMFB0000000071778165',
    donate_name: 'Muhammad Noman',
    donate_image: '',
    donate_reminder_min: '30'
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('settings');

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const [r, s] = await Promise.all([api.get('/donate-requests'), api.get('/donate-settings')]);
    if (r?.requests) setRequests(r.requests);
    if (s?.settings) setSettings(p => ({ ...p, ...s.settings }));
    setLoading(false);
  }
  async function save() {
    setSaving(true);
    const d = await api.post('/donate-settings', { updates: settings });
    if (d?.success) toast.success('Donate settings save ho gayi!'); else toast.error(d?.error || 'Error');
    setSaving(false);
  }

  if (loading) return <div style={{ textAlign: 'center', padding: 60 }}><span className="spinner" style={{ width: 32, height: 32 }} /></div>;

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="section-title">💰 Donate Madrasa</div>
          <div className="section-sub">EasyPaisa/IBAN details aur donate requests</div>
        </div>
        <div style={{ padding: '4px 12px', borderRadius: 20, fontSize: 12, background: 'var(--gold-900)', border: '1px solid var(--gold-700)', color: 'var(--gold-300)' }}>
          {requests.length} Requests
        </div>
      </div>

      <div style={{ display: 'flex', gap: 4, marginBottom: 20, borderBottom: '1px solid var(--border)' }}>
        {['settings', 'requests'].map(t => (
          <button key={t} onClick={() => setTab(t)} style={{ padding: '8px 16px', background: 'none', border: 'none', borderBottom: tab === t ? '2px solid var(--gold-400)' : '2px solid transparent', color: tab === t ? 'var(--gold-300)' : 'var(--text-muted)', cursor: 'pointer', fontSize: 13, fontWeight: tab === t ? 600 : 400, marginBottom: -1 }}>
            {t === 'settings' ? '⚙️ Payment Settings' : `📋 Requests (${requests.length})`}
          </button>
        ))}
      </div>

      {tab === 'settings' && (
        <div style={{ maxWidth: 560 }}>
          <div className="card">
            <div style={{ fontSize: 13, fontWeight: 600, color: 'var(--text-primary)', marginBottom: 20 }}>💳 Payment Details</div>
            <div className="field">
              <label className="label">EasyPaisa Number</label>
              <input className="input" value={settings.donate_easypaisa} onChange={e => setSettings(p => ({ ...p, donate_easypaisa: e.target.value }))} disabled={!can('settings')} placeholder="03xxxxxxxxx" />
            </div>
            <div className="field">
              <label className="label">IBAN Number</label>
              <input className="input" value={settings.donate_iban} onChange={e => setSettings(p => ({ ...p, donate_iban: e.target.value }))} disabled={!can('settings')} placeholder="PK56TMFB..." />
            </div>
            <div className="field">
              <label className="label">Account Holder Name</label>
              <input className="input" value={settings.donate_name} onChange={e => setSettings(p => ({ ...p, donate_name: e.target.value }))} disabled={!can('settings')} />
            </div>
            <div className="field">
              <label className="label">QR / Donate Image URL</label>
              <input className="input" value={settings.donate_image} onChange={e => setSettings(p => ({ ...p, donate_image: e.target.value }))} disabled={!can('settings')} placeholder="https://..." />
              {settings.donate_image && (
                <img src={settings.donate_image} alt="Donate" style={{ maxWidth: 200, marginTop: 8, borderRadius: 8, border: '1px solid var(--border)' }} onError={e => { e.target.style.display = 'none'; }} />
              )}
            </div>
            <div className="field">
              <label className="label">Reminder Delay (minutes)</label>
              <input className="input" type="number" value={settings.donate_reminder_min} onChange={e => setSettings(p => ({ ...p, donate_reminder_min: e.target.value }))} disabled={!can('settings')} style={{ maxWidth: 120 }} />
              <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 4 }}>
                User ke "No" kehne ke baad kitne minute baad reminder bheja jaye
              </div>
            </div>
            {can('settings') && (
              <button className="btn btn-primary" onClick={save} disabled={saving}>
                {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : <Save size={14} />}
                {saving ? ' Saving...' : ' Save Karein'}
              </button>
            )}
          </div>
        </div>
      )}

      {tab === 'requests' && (
        requests.length === 0
          ? <div className="card" style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>Koi donate request nahi</div>
          : <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              {requests.map((r, i) => (
                <div key={i} className="card" style={{ padding: '12px 16px' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 4 }}>{new Date(r.created_at).toLocaleString()}</div>
                  <div style={{ fontSize: 13, color: 'var(--text-primary)' }}>{r.message}</div>
                </div>
              ))}
            </div>
      )}
    </div>
  );
}